import * as commonConfig from "./commonConfig";
import * as config from "./config";

const mergedConfig = {
  ...commonConfig,
  ...config,
};

export const NETWORK_INTERFACE_URL = mergedConfig.NETWORK_INTERFACE_URL;
export const SSO_GET_TOKEN_URL = mergedConfig.SSO_GET_TOKEN_URL;
export const SSO_RENEW_TOKEN_URL = mergedConfig.SSO_RENEW_TOKEN_URL;
export const SSO_RESTORE_PASS_URL = mergedConfig.SSO_RESTORE_PASS_URL;
export const CLIENT_PRIVILEGES_CONFIG = mergedConfig.CLIENT_PRIVILEGES_CONFIG;
export const OKTELL_WS_URL = mergedConfig.OKTELL_WS_URL;
export const USE_RAVEN = mergedConfig.USE_RAVEN;



// WEBPACK FOOTER //
// ./src/config/index.js